(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-title"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const titleWrappers = document.querySelectorAll('[data-title-expandable]');

    titleWrappers.forEach(function(wrapper) {
        const titleText = wrapper.querySelector('.title-text');

        if (titleText) {
            // 检测标题是否溢出（超过一行）
            const isOverflowing = titleText.scrollHeight > titleText.clientHeight;

            if (isOverflowing) {
                // 只有溢出时才添加点击功能
                wrapper.classList.add('has-overflow');

                wrapper.addEventListener('click', function() {
                    const isExpanded = this.classList.toggle('expanded');
                    if (isExpanded) {
                        titleText.classList.add('expanded');
                    } else {
                        titleText.classList.remove('expanded');
                    }
                });
            }
        }
    });
});
  } catch(e) { console.error(e); }
})();

})();
